/*
 * quotationmarks
 *
 * Replace all weird quotationmarks with the one allowed quotationmark.
 *
 * Quotationmark info: https://apple.stackexchange.com/questions/299505/ios-11-default-quotation-mark-changed-to-and
 *
 * GDL Requirements
 * -https://novamedia-jira.atlassian.net/browse/VLC-3689?focusedCommentId=258284
 */

const quotationmarks = () => {
  $('input').on('keydown', function replacer(evt) {
    if (evt.key === '‘' || evt.key === '’' || evt.key === '“' || evt.key === '”' || evt.key === '"') {
      evt.preventDefault();
      $(this).val(`${$(this).val()}'`);
    }
  });
};

export default quotationmarks;
